export default __webpack_public_path__ + "static/images/gongzhonghao.c5eebe8d.png";